import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { VelocityLimitService } from '../services/velocity-limit.service';
import {
  fetchVelocityLimitList,
  loadedVelocityLimitList,
  failedVelocityLimitList,
  updateVelocityLimitListFilter,
} from './velocity-limit-list.actions';
import { selectVelocityLimitListFilter } from './velocity-limit-list.selector';

@Injectable()
export class VelocityLimitListEffect {
  loadVelocityLimitList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchVelocityLimitList),
      switchMap(({ filter }) =>
        this.velocityLimitService.getVelocityLimitList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedVelocityLimitList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedVelocityLimitList();
            }
          }),
          catchError(() => of(failedVelocityLimitList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateVelocityLimitListFilter),
      concatLatestFrom(() => this.store.select(selectVelocityLimitListFilter)),
      switchMap(([action, prevFilter]) =>
        of(
          fetchVelocityLimitList({
            filter: { ...prevFilter, ...action.filter },
          })
        )
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly velocityLimitService: VelocityLimitService
  ) {}
}
